import React, { useEffect, useState } from "react";
import { EntitiesTableRow } from "./entitiesTableRow";

export const EntitiesTable = ({
	data,
	setEntitieToEdit,
	deleteEntitie,
	openModal,
	type,
}) => {
	const [showData, setShowData] = useState(data);

	useEffect(() => {
		setShowData(data);
	}, [data]);

	function handleSearch(e) {
		// console.log("e:", e.target.value);
		if (e.target.value === "") {
			return setShowData(data);
		}
		// console.log("data: ", data);
		setShowData(
			data.filter((item) => item.name.toLowerCase().includes(e.target.value))
		);
	}

	return (
		<div>
			<div className="document-search">
				<h2 className="title-search">Buscar</h2>
				<input
					type="search"
					name=""
					id=""
					onChange={handleSearch}
					className="search-box"
				/>
			</div>
			<h3 className="titulo1">Lista de - {type}</h3>
			<table className="tabla-procesos">
				<thead>
					<tr className="fila-tabla-procesos">
						<th className="titleTableDocuments03">Nombre</th>
						<th className="titleTableDocuments03">Acción</th>
					</tr>
				</thead>
				<tbody>
					{showData.length > 0 ? (
						showData.map((el) => (
							<EntitiesTableRow
								key={el.id}
								el={el}
								setEntitieToEdit={setEntitieToEdit}
								openModal={openModal}
								deleteEntitie={deleteEntitie}
							/>
						))
					) : (
						<tr>
							<td colSpan="3">Sin datos</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};
